<script>
	import { getPlanMetadata } from '$lib/utils/plans-metadata';
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import * as MEALS from '$ravioli/lib/assets/images/meals';
	import rightArrow from '$ravioli/lib/assets/icons/right-arrow.svg';
	

	let mealPlans = [
		{
			name: 'Vegetarian Meal Plan',
			price: '450',
			image: MEALS.vegMeal,
			link: `/apex/plans/${getPlanMetadata('vegetarian-meal-plan').id}/purchase`
		},
		{
			name: 'Non-Vegetarian Meal Plan',
			price: '450',
			image: MEALS.nonVegMeal,
			link: `/apex/plans/${getPlanMetadata('non-vegetarian-meal-plan').id}/purchase`
		},
		{
			name: 'Custom Meal Plan',
			price: '450',
			image: MEALS.customMeal,
			link: `/apex/plans/${getPlanMetadata('custom-meal-plan').id}/purchase`
		}
	];
</script>

<div id="our-meal-plans" class="font-roboto scroll-mt-28">
	<div class="flex flex-col gap-3 md:gap-5">
		<p class="title-underline relative mx-auto max-w-fit text-xl font-medium uppercase md:text-2xl">
			Our meal plans
		</p>
		<p class="text-center text-base">
			Our meals are designed by certified nutritionists, prepared by award winning chefs and
			delivered fresh everyday with love.
		</p>
	</div>
	<ul class="mt-8 flex flex-col gap-6 md:mt-10 md:flex-row md:justify-center md:gap-10">
		{#each mealPlans as plan}
			<li
				class="relative flex gap-3 overflow-hidden rounded-2xl bg-white shadow-[0px_2px_12px_0px_rgba(0,_0,_0,_0.08)] md:flex-col-reverse md:gap-0"
			>
				<div
					class="flex max-w-[156px] flex-1 flex-col justify-between gap-7 py-6 pl-4 sm:max-w-[180px] md:-mt-12 md:max-w-none md:pr-4 md:pt-0"
				>
					<div>
						<p class="text-xl font-medium">{plan.name}</p>
						<p class="text-sm md:text-base">
							Starting from <span class="font-bold">₹{plan.price}</span>/meal
						</p>
					</div>
					<a
						href={plan.link}
						class="flex w-[156px] items-center gap-3 rounded-lg bg-[#ED292D] px-6 py-[10px] md:w-auto md:justify-center"
					>
						<span class="text-sm text-white md:text-base">Get Started</span>
						<img class="h-5 w-5 object-cover" src={rightArrow} alt="right arrow" />
					</a>
				</div>
				<div class="flex-auto md:flex">
					<ImageOptimiser
						src={plan.image}
						alt="meal plan images"
						imageSourceType="internal"
						classes={{
							container: 'flex-none',
							image:
								'w-44 h-44 rounded-full absolute -right-10 -top-10 md:-right-16 md:-top-[4.5rem] md:relative md:w-72 md:h-72 object-cover object-[top center] flex-1 '
						}}
					/>
				</div>
			</li>
		{/each}
	</ul>
	<ul
		class="our-prod-desc mt-8 flex flex-wrap items-center justify-center gap-2 gap-x-5 text-sm md:mx-auto md:mt-10  md:max-w-[748px] md:gap-8 md:text-base md:font-medium whitespace-nowrap"
	>
		<li class="our-prod-desc-list relative w-fit">No Artificial Preservatives</li>
		<li class="our-prod-desc-list relative w-fit">Cooked fresh every day</li>
		<li class="our-prod-desc-list relative w-fit">No Cooking required</li>
		<li class="our-prod-desc-list relative w-fit">Organic ingredients</li>
	</ul>
</div>

<style>
	.our-prod-desc li:nth-child(odd) {
		text-align: right;
	}
	/* .our-prod-desc-list:nth-child(odd)::after {
		display: none;
	} */
	.our-prod-desc-list::after {
		content: '';
		position: absolute;
		left: -12px;
		width: 6px;
		height: 6px;
		background-color: #ef4044;
		border-radius: 3px;
		top: 50%;
		transform: translateY(-50%);
	}
	@media screen and (min-width: 768px) {
		.our-prod-desc-list::after {
			left: -20px;
			width: 8px;
			height: 8px;
			border-radius: 4px;
		}
		.our-prod-desc li:nth-child(odd) {
			text-align: left;
		}
		.our-prod-desc-list:nth-child(odd)::after {
			display: block;
		}
		/* .our-prod-desc-list:first-child::after {
			display: none;
		} */
	}
</style>
